import styled from 'styled-components';

export const H2 = styled.h2`
  width: 100%;
  font-family: lato !important;
  text-align: left !important;
  font-weight: bold !important;
  margin-bottom: 1em;
  font-size: 26px;
`;
